import MKKVStorage from '@/lib/zustand-storage'
import type { AuthenticationStore } from '@/store/auth/AuthenticationStore'
import {
	authenticationStoreSelector,
	createAuthenticationSlice,
} from '@/store/auth/AuthenticationStore'
import type { SessionStore } from '@/store/session/SessionStore'
import { createSessionSlice, sessionStoreSelector } from '@/store/session/SessionStore'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { useShallow } from 'zustand/react/shallow'

export interface RootStore extends AuthenticationStore, SessionStore {
	_hasHydratedFromStorage: boolean
	setHasHydratedFromStorage: (state: boolean) => void
}

export const useStore = create<RootStore>()(
	persist(
		(...data) => ({
			...createAuthenticationSlice(...data),
			...createSessionSlice(...data),
			_hasHydratedFromStorage: false,
			setHasHydratedFromStorage: (state) => {
				const set = data[0]
				set({
					_hasHydratedFromStorage: state,
				})
			},
		}),
		{
			name: 'wally-patient-storage',
			storage: createJSONStorage(() => MKKVStorage),
			onRehydrateStorage: () => (state) => {
				state?.setHasHydratedFromStorage(true)
			},
		}
	)
)

export const useAuthStore = () => useStore(useShallow(authenticationStoreSelector))
export const useSessionStore = () => useStore(useShallow(sessionStoreSelector))
